<template>
  <div class="auth-wrapper">
    <div class="auth-box">
      <div class="auth-box__header">
        <img
          :src="require('@/assets/images/logo-type.svg')"
          width="127"
          height="50"
          :alt="$t('BAZAAR')"
        />
      </div>

      <div v-loading="isLoading" class="auth-box__form">
        <RegisterAgentWithoutPassword
          v-if="hasPassword"
          :publisher-email="publisherEmail"
          :agent-email="agentEmail"
          :token="token"
          @success="loginUser"
        />
        <RegisterAgentWithPassword
          v-else
          :publisher-email="publisherEmail"
          :agent-email="agentEmail"
          :token="token"
          @success="loginUser"
        />
      </div>

      <div class="auth-box__link">
        <LocaleSelector />
      </div>
    </div>
  </div>
</template>

<script>
import { Agents } from '@/api/api';
import RegisterAgentWithPassword from './RegisterAgentWithPassword';
import RegisterAgentWithoutPassword from './RegisterAgentWithoutPassword';
import LocaleSelector from '@@/common/LocaleSelector';

export default {
  name: 'RegisterAgent',

  components: {
    RegisterAgentWithoutPassword,
    RegisterAgentWithPassword,
    LocaleSelector,
  },

  data() {
    return {
      isLoading: false,

      isSubmitting: false,

      token: null,
      agentEmail: null,
      publisherEmail: null,

      hasPassword: false,
    };
  },

  created() {
    const { activation_token: activationToken } = this.$route.query;
    this.isLoading = true;
    if (activationToken) {
      this.token = activationToken;
      return this.getTokenInfo().then(() => {
        this.isLoading = false;
      });
    }
    this.redirectToLogin();
  },

  methods: {
    getTokenInfo() {
      return Agents.validateInvitation({ token: this.token })
        .then(
          ({
            body: {
              has_password: hasPassword,
              agent_email: agentEmail,
              publisher_email: publisherEmail,
            },
          }) => {
            this.hasPassword = hasPassword;
            this.agentEmail = agentEmail;
            this.publisherEmail = publisherEmail;
          },
        )
        .catch(() => {
          this.redirectToLogin();
        });
    },

    loginUser(token) {
      this.$auth.loginWithToken(token).then(() => {
        this.$router.replace({ name: 'apps' });
      });
    },

    redirectToLogin() {
      this.$router.replace({ name: 'login' });
    },
  },
};
</script>
